<template>
  <q-dialog :visible="visible" :title="title" width="800px" :innerScroll="false" @close="handleClose">
    <el-form :rules="rules" :model="form" label-width="140px" size="small" ref="formRef" class="demo-form-inline">
      <el-row type="flex" :gutter="20" class="form-row">
        <el-col :span="24">
          <el-form-item label="商品编号:">
            <div>{{ form.goodsCode }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="商品名称:">
            <div>{{ form.goodsName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="基础零售价:">
            <el-tooltip effect="dark" :content="String(form.retailPrice)" class="tooltip-block">
              <span class="retail-price">{{ form.retailPrice }}</span>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品标价(划线价):" prop="tagPrice">
            <el-input type="text" autocomplete="off" min="0" maxlength="9" v-model="form.tagPrice" size="small" placeholder="请输入产品标价(划线价)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="A类价:" :prop="isAClassPrice ? 'dailyRetailPrice' : ''">
            <el-input
              type="text"
              autocomplete="off"
              min="0"
              maxlength="9"
              v-model="form.dailyRetailPrice"
              size="small"
              placeholder="请输入A类价"
              :disabled="!isAClassPrice"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="清仓销售价:" prop="clearancePrice">
            <el-input type="text" autocomplete="off" min="0" maxlength="9" v-model="form.clearancePrice" size="small" placeholder="请输入清仓销售价"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="销售状态:" prop="saleStatus">
            <el-select v-model="form.saleStatus" size="small" placeholder="请选择销售状态">
              <el-option
                v-for="item in saleStatusList.filter((v) => v.saleStatus != '空白')"
                :value="item.saleStatus"
                :label="item.saleStatus"
                :key="item.saleStatus"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
        <el-col :span="24">
          <el-form-item label="调整原因:" prop="adjustmentCause">
            <el-input
              type="textarea"
              v-model.trim="form.adjustmentCause"
              size="small"
              maxlength="100"
              show-word-limit
              :rows="4"
              placeholder="请输入调整原因"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="showValidityDate">
          <el-form-item label="有效期:" prop="validtyStart">
            <el-date-picker v-model="form.validtyStart" type="date" placeholder="开始日期" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="showValidityDate">
          <el-form-item class="auto-label-width" label="至" prop="validtyEnd">
            <el-date-picker v-model="form.validtyEnd" type="date" placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose" size="medium">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm" size="medium">确定</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'SalespriceEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    actionType: {
      type: String,
      default: 'add',
    },
    saleStatusList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const validate = (rule, value, callback) => {
      const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2}))|0)$/;
      if (value && !reg.test(value)) {
        callback(new Error('请输入最多包含两位小数的正数!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      form: {},
      rules: {
        tagPrice: [{ required: true, message: '请输入产品标价(划线价)', trigger: 'blur' }, { validator: validate }],
        dailyRetailPrice: [{ required: true, message: '请输入A类价', trigger: 'blur' }, { validator: validate }],
        clearancePrice: [{ required: false, message: '请输入清仓销售价', trigger: 'blur' }, { validator: validate }],
        adjustmentCause: [{ required: false, message: '请输入调整原因', trigger: 'blur' }],
        validtyStart: [{ required: true, message: '请填写有效期开始日期', trigger: 'blur' }],
        validtyEnd: [{ required: true, message: '请填写有效期结束日期', trigger: 'blur' }],
      },
    };
  },
  computed: {
    title() {
      return this.actionType === 'add' ? '新增' : '编辑';
    },
    permitList() {
      return JSON.parse(localStorage.getItem('permitList')) || [];
    },
    isAClassPrice() {
      const jurisdiction = 'ec-pc-new$goodsManage$priceManagement$salespriceIndex$editAClassPrice';
      return this.permitList.includes(jurisdiction);
    },
    isTempPrice() {
      return !this.form.validtyStart && !this.form.validtyEnd;
    },
    showValidityDate() {
      return (!this.isTempPrice && this.actionType === 'modify') || this.actionType === 'add';
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      const {
        id,
        goodsCode,
        goodsName,
        retailPrice,
        promotionPriceA,
        promotionPriceB,
        promotionPriceC,
        tagPrice,
        dailyRetailPrice,
        promotionRetailPrice,
        clearancePrice,
        combinationPrice,
        createdBy,
        adjustmentCause,
        validtyStart,
        validtyEnd,
        redEnvelopeOne,
        redEnvelopeTwo,
        redEnvelopeThree,
        saleStatus,
      } = this.row;
      this.form = {
        id,
        goodsCode,
        goodsName,
        retailPrice,
        promotionPriceA,
        promotionPriceB,
        promotionPriceC,
        tagPrice,
        dailyRetailPrice,
        promotionRetailPrice,
        clearancePrice,
        combinationPrice,
        createdBy,
        adjustmentCause,
        validtyStart,
        validtyEnd,
        redEnvelopeOne,
        redEnvelopeTwo,
        redEnvelopeThree,
        saleStatus,
      };
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const param = this.buildParam();
        const api = this.actionType === 'add' ? this.$q.goods.insertGoodsSalesPrice : this.$q.goods.updateGoodsSalesPrice;

        let data = {};
        if (this.actionType === 'add') {
          Object.keys(param).forEach((v) => {
            data[v] = param[v] || null;
          });
        } else {
          data = param;
        }

        api({ data })
          .then((res) => {
            if (res.code === '200') {
              this.$notify({
                title: '成功',
                message: this.actionType === 'add' ? '新增商品销售价成功' : '修改商品销售价成功',
                type: 'success',
                duration: 2000,
              });
              this.$emit('success');
              this.handleClose();
            } else {
              this.$message.error(res.message);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    buildParam() {
      const {
        id,
        goodsCode,
        retailPrice,
        promotionPriceA,
        promotionPriceB,
        promotionPriceC,
        tagPrice,
        dailyRetailPrice,
        promotionRetailPrice,
        clearancePrice,
        combinationPrice,
        adjustmentCause,
        validtyStart,
        validtyEnd,
        redEnvelopeOne,
        redEnvelopeTwo,
        redEnvelopeThree,
        saleStatus,
      } = this.form;
      return {
        id,
        goodsCode,
        retailPrice,
        promotionPriceA,
        promotionPriceB,
        promotionPriceC,
        tagPrice,
        dailyRetailPrice,
        promotionRetailPrice,
        clearancePrice,
        combinationPrice,
        adjustmentCause,
        validtyStart,
        validtyEnd,
        redEnvelopeOne,
        redEnvelopeTwo,
        redEnvelopeThree,
        saleStatus,
      };
    },
  },
};
</script>

<style lang="stylus" scoped>
.auto-label-width
  >>> .el-form-item__label
    width 50px !important
  >>> .el-form-item__content
    margin-left 50px !important
    margin-right 90px

.form-row
  flex-wrap wrap

.tooltip-block
  display block

.retail-price
  display block
  width 100%
  text-overflow ellipsis
  overflow hidden
  white-space nowrap
</style>
